import { Component } from '@angular/core';
import { Item } from 'src/app/models/item';
import { LookUpService } from 'src/app/services/lookup.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-mmv-mapping',
  templateUrl: './mmv-mapping.component.html',
  styleUrls: ['./mmv-mapping.component.css']
})
export class MmvMappingComponent {
  productsList = [{ text: "Two Wheeler", value: 2 }, { text: "Four Wheeler", value: 1 }, { text: "Commercial", value: 3 }];
  vehicleCategoryList = [{ text: "Goods Carrying", value: "Goods Carrying" }, { text: "Passenger Carrying", value: "Passenger Carrying" }, { text: "Miscellaneous", value: "Miscellaneous" }];
  vehicleType: number = 2;
  fuelTypeList: any = [];
  fuelType: string = "";
  makeList: Item[] = [];
  modelList: Item[] = [];
  selectedMakes: any = "";
  selectedModels: any = "";
  activeInsuranceCompanyList: any = [];
  activePanel = 1;
  vehicleCategory = "GCV";
  showMappingDetails:boolean = false;

  Digit_Insurance_1: boolean = false;
  Royal_Sundaram_2: boolean = false;
  HDFC_ERGO_3: boolean = false;
  ICICI_Lombard_4: boolean = false;
  IFFCO_Tokio_5: boolean = false;
  Raheja_QBE_6: boolean = false;
  Reliance_General_7: boolean = false;
  Shriram_General_8: boolean = false;
  Universal_Sompo_9: boolean = false;
  Navi_Insurance_10: boolean = false;
  Bajaj_Allianz_General_11: boolean = false;
  National_Insurance_12: boolean = false;
  Oriental_Insurance_13: boolean = false;
  Future_Generali_14: boolean = false;
  Edelweiss_General_15: boolean = false;
  Kotak_General_16: boolean = false;
  Liberty_General_17: boolean = false;
  Magma_HDI_18: boolean = false;
  SBI_General_19: boolean = false;
  Tata_AIG_20: boolean = false;
  Acko_21: boolean = false;
  Bharti_AXA_22: boolean = false;
  Chola_MS_23: boolean = false;
  DHFL_GI_24: boolean = false;
  New_India_Assurance_25: boolean = false;
  United_India_Insurance_26: boolean = false;
  Zuno_Insurance_27: boolean = false;
  Aditya_Birla_Health_28: boolean = false;
  AIC_of_India_29: boolean = false;
  Care_Health_30: boolean = false;
  ManipalCigna_31: boolean = false;
  Niva_Bupa_32: boolean = false;
  Star_Health_33: boolean = false;

  Digit_Insurance_VehicleCode_1: string = "";
  Royal_Sundaram_VehicleCode_2: string = "";
  HDFC_ERGO_VehicleCode_3: string = "";
  ICICI_Lombard_VehicleCode_4: string = "";
  IFFCO_Tokio_VehicleCode_5: string = "";
  Raheja_QBE_VehicleCode_6: string = "";
  Reliance_General_VehicleCode_7: string = "";
  Shriram_General_VehicleCode_8: string = "";
  Universal_Sompo_VehicleCode_9: string = "";
  Navi_Insurance_VehicleCode_10: string = "";
  Bajaj_Allianz_General_VehicleCode_11: string = "";
  National_Insurance_VehicleCode_12: string = "";
  Oriental_Insurance_VehicleCode_13: string = "";
  Future_Generali_VehicleCode_14: string = "";
  Edelweiss_General_VehicleCode_15: string = "";
  Kotak_General_VehicleCode_16: string = "";
  Liberty_General_VehicleCode_17: string = "";
  Magma_HDI_VehicleCode_18: string = "";
  SBI_General_VehicleCode_19: string = "";
  Tata_AIG_VehicleCode_20: string = "";
  Acko_VehicleCode_21: string = "";
  Bharti_AXA_VehicleCode_22: string = "";
  Chola_MS_VehicleCode_23: string = "";
  DHFL_GI_VehicleCode_24: string = "";
  New_India_Assurance_VehicleCode_25: string = "";
  United_India_Insurance_VehicleCode_26: string = "";
  Zuno_Insurance_VehicleCode_27: string = "";
  Aditya_Birla_Health_VehicleCode_28: string = "";
  AIC_of_India_VehicleCode_29: string = "";
  Care_Health_VehicleCode_30: string = "";
  ManipalCigna_VehicleCode_31: string = "";
  Niva_Bupa_VehicleCode_32: string = "";
  Star_Health_VehicleCode_33: string = "";

  Digit_Insurance_MappedDetails_1: string = "";
  Royal_Sundaram_MappedDetails_2: string = "";
  HDFC_ERGO_MappedDetails_3: string = "";
  ICICI_Lombard_MappedDetails_4: string = "";
  IFFCO_Tokio_MappedDetails_5: string = "";
  Raheja_QBE_MappedDetails_6: string = "";
  Reliance_General_MappedDetails_7: string = "";
  Shriram_General_MappedDetails_8: string = "";
  Universal_Sompo_MappedDetails_9: string = "";
  Navi_Insurance_MappedDetails_10: string = "";
  Bajaj_Allianz_General_MappedDetails_11: string = "";
  National_Insurance_MappedDetails_12: string = "";
  Oriental_Insurance_MappedDetails_13: string = "";
  Future_Generali_MappedDetails_14: string = "";
  Edelweiss_General_MappedDetails_15: string = "";
  Kotak_General_MappedDetails_16: string = "";
  Liberty_General_MappedDetails_17: string = "";
  Magma_HDI_MappedDetails_18: string = "";
  SBI_General_MappedDetails_19: string = "";
  Tata_AIG_MappedDetails_20: string = "";
  Acko_MappedDetails_21: string = "";
  Bharti_AXA_MappedDetails_22: string = "";
  Chola_MS_MappedDetails_23: string = "";
  DHFL_GI_MappedDetails_24: string = "";
  New_India_Assurance_MappedDetails_25: string = "";
  United_India_Insurance_MappedDetails_26: string = "";
  Zuno_Insurance_MappedDetails_27: string = "";
  Aditya_Birla_Health_MappedDetails_28: string = "";
  AIC_of_India_MappedDetails_29: string = "";
  Care_Health_MappedDetails_30: string = "";
  ManipalCigna_MappedDetails_31: string = "";
  Niva_Bupa_MappedDetails_32: string = "";
  Star_Health_MappedDetails_33: string = "";

  Digit_Insurance_Make_1: string = "";
  Royal_Sundaram_Make_2: string = "";
  HDFC_ERGO_Make_3: string = "";
  ICICI_Lombard_Make_4: string = "";
  IFFCO_Tokio_Make_5: string = "";
  Raheja_QBE_Make_6: string = "";
  Reliance_General_Make_7: string = "";
  Shriram_General_Make_8: string = "";
  Universal_Sompo_Make_9: string = "";
  Navi_Insurance_Make_10: string = "";
  Bajaj_Allianz_General_Make_11: string = "";
  National_Insurance_Make_12: string = "";
  Oriental_Insurance_Make_13: string = "";
  Future_Generali_Make_14: string = "";
  Edelweiss_General_Make_15: string = "";
  Kotak_General_Make_16: string = "";
  Liberty_General_Make_17: string = "";
  Magma_HDI_Make_18: string = "";
  SBI_General_Make_19: string = "";
  Tata_AIG_Make_20: string = "";
  Acko_Make_21: string = "";
  Bharti_AXA_Make_22: string = "";
  Chola_MS_Make_23: string = "";
  DHFL_GI_Make_24: string = "";
  New_India_Assurance_Make_25: string = "";
  United_India_Insurance_Make_26: string = "";
  Zuno_Insurance_Make_27: string = "";
  Aditya_Birla_Health_Make_28: string = "";
  AIC_of_India_Make_29: string = "";
  Care_Health_Make_30: string = "";
  ManipalCigna_Make_31: string = "";
  Niva_Bupa_Make_32: string = "";
  Star_Health_Make_33: string = "";


  //Make List
  Digit_Insurance_1_MakeList: Item[] = [];
  Royal_Sundaram_2_MakeList: Item[] = [];
  HDFC_ERGO_3_MakeList: Item[] = [];
  ICICI_Lombard_4_MakeList: Item[] = [];
  IFFCO_Tokio_5_MakeList: Item[] = [];
  Raheja_QBE_6_MakeList: Item[] = [];
  Reliance_General_7_MakeList: Item[] = [];
  Shriram_General_8_MakeList: Item[] = [];
  Universal_Sompo_9_MakeList: Item[] = [];
  Navi_Insurance_10_MakeList: Item[] = [];
  Bajaj_Allianz_General_11_MakeList: Item[] = [];
  National_Insurance_12_MakeList: Item[] = [];
  Oriental_Insurance_13_MakeList: Item[] = [];
  Future_Generali_14_MakeList: Item[] = [];
  Edelweiss_General_15_MakeList: Item[] = [];
  Kotak_General_16_MakeList: Item[] = [];
  Liberty_General_17_MakeList: Item[] = [];
  Magma_HDI_18_MakeList: Item[] = [];
  SBI_General_19_MakeList: Item[] = [];
  Tata_AIG_20_MakeList: Item[] = [];
  Acko_21_MakeList: Item[] = [];
  Bharti_AXA_22_MakeList: Item[] = [];
  Chola_MS_23_MakeList: Item[] = [];
  DHFL_GI_24_MakeList: Item[] = [];
  New_India_Assurance_25_MakeList: Item[] = [];
  United_India_Insurance_26_MakeList: Item[] = [];
  Zuno_Insurance_27_MakeList: Item[] = [];
  Aditya_Birla_Health_28_MakeList: Item[] = [];
  AIC_of_India_29_MakeList: Item[] = [];
  Care_Health_30_MakeList: Item[] = [];
  ManipalCigna_31_MakeList: Item[] = [];
  Niva_Bupa_32_MakeList: Item[] = [];
  Star_Health_33_MakeList: Item[] = [];

  //Model List
  Digit_Insurance_1_ModelList: Item[] = [];
  Royal_Sundaram_2_ModelList: Item[] = [];
  HDFC_ERGO_3_ModelList: Item[] = [];
  ICICI_Lombard_4_ModelList: Item[] = [];
  IFFCO_Tokio_5_ModelList: Item[] = [];
  Raheja_QBE_6_ModelList: Item[] = [];
  Reliance_General_7_ModelList: Item[] = [];
  Shriram_General_8_ModelList: Item[] = [];
  Universal_Sompo_9_ModelList: Item[] = [];
  Navi_Insurance_10_ModelList: Item[] = [];
  Bajaj_Allianz_General_11_ModelList: Item[] = [];
  National_Insurance_12_ModelList: Item[] = [];
  Oriental_Insurance_13_ModelList: Item[] = [];
  Future_Generali_14_ModelList: Item[] = [];
  Edelweiss_General_15_ModelList: Item[] = [];
  Kotak_General_16_ModelList: Item[] = [];
  Liberty_General_17_ModelList: Item[] = [];
  Magma_HDI_18_ModelList: Item[] = [];
  SBI_General_19_ModelList: Item[] = [];
  Tata_AIG_20_ModelList: Item[] = [];
  Acko_21_ModelList: Item[] = [];
  Bharti_AXA_22_ModelList: Item[] = [];
  Chola_MS_23_ModelList: Item[] = [];
  DHFL_GI_24_ModelList: Item[] = [];
  New_India_Assurance_25_ModelList: Item[] = [];
  United_India_Insurance_26_ModelList: Item[] = [];
  Zuno_Insurance_27_ModelList: Item[] = [];
  Aditya_Birla_Health_28_ModelList: Item[] = [];
  AIC_of_India_29_ModelList: Item[] = [];
  Care_Health_30_ModelList: Item[] = [];
  ManipalCigna_31_ModelList: Item[] = [];
  Niva_Bupa_32_ModelList: Item[] = [];
  Star_Health_33_ModelList: Item[] = [];


  constructor(private lookUpService: LookUpService) {
    this.vehicleTypeChange();
  }

  async vehicleTypeChange() {
    this.fuelTypeList = [];
    this.fuelType = "";
    this.showMappingDetails = false;
    this.loadFuelList();
    if (this.vehicleType < 3) {
      this.loadFuelList();
    }
  }

  async vehicleCategoryChange() {
    this.fuelTypeList = [];
    this.fuelType = "";
    this.loadFuelList();
    this.showMappingDetails = false;
  }

  async loadFuelList() {
    this.fuelTypeChange();
    let obj = {
      type: this.vehicleType,
      vehicleCategory: this.vehicleCategory
    }
    let res = await this.lookUpService.GetVehicleFuelByCategory(obj);
    if (res != null && res.isSuccess && res.result) {
      this.fuelTypeList = res.result?.map((m: any) => { return { text: m, value: m } });
      this.fuelTypeList.unshift({ text: "Select Fuel Type", value: "" });
    }
  }

  async fuelTypeChange() {
    this.resetMappingField();
    this.resetActiveInsuranceComapny();
    this.resetMakeList();
    this.resetModelList();
    this.makeList = [];
    this.modelList = [];
    if(this.fuelType && this.fuelType != ""){
      this.loadMakeList();      
    }
  }

  async loadMakeList() {
    let obj = {
      type: this.vehicleType,
      fuel: this.fuelType,
      vehicleCategory: this.vehicleCategory
    }
    let res = await this.lookUpService.GetVehicleMakeByFuelCategory(obj);
    if (res != null && res.isSuccess && res.result) {
      this.makeList = res.result.map((m: any) => { return { name: m, id: m, checked: false } });
      //this.fuelTypeList.unshift({text : "Select Fuel Type", value : ""});
    }
  }

  onMakeSelect(data: Item[]) {
    this.selectedMakes = data.map((m: Item) => { return m.id }).toString();
    if (this.selectedMakes != "")
    {
      this.loadActiveInsuranceCompanies();
      this.loadModelList();
    }
  }

  async loadModelList() {
    this.modelList = [];
    let obj = {
      type: this.vehicleType,
      fuel: this.fuelType,
      companyName: this.selectedMakes,
      vehicleCategory: this.vehicleCategory
    }
    let res = await this.lookUpService.GetVehicleModelVariantByFuelCategoryMake(obj);
    if (res != null && res.isSuccess && res.result) {
      this.modelList = res.result.map((m: any) => {
        return {
          name: m.modelName + ' ' + m.variantName + (this.vehicleType < 3 || (this.vehicleType == 3 && this.vehicleCategory == "Passenger Carrying") ? ' | ' + m.cubicCapacity + ' CC' : ' | GVW - ' + m.gvw)  + ' | Seating Capacity - ' + m.seatingCapacity  + ' | Body Type - ' + m.bodyType?.trim() + ' | ' + m.vehicleCode?.trim(),
          id: m.id,
          name1: "",
          name2: m.vehicleCode,
          checked: false
        }
      });
    }
  }

  onModelSelect(data: Item[]) {
    this.showMappingDetails = true;
    this.resetMappingField();
    this.selectedModels = data.map((m: Item) => { return m.id }).toString();
    if(this.selectedModels && this.selectedModels != undefined && this.selectedModels != "")
    {
      this.GetMMVMappingById(parseInt(this.selectedModels));
    }
  }

  async GetMMVMappingById(id:number){
    let reqObj = {
      type: this.vehicleType,
      vehicleCategory: this.vehicleCategory,
      id: id
    }
    let res = await this.lookUpService.GetMMVMappingById(reqObj);
    if (res != null && res.isSuccess && res.result && res.result != "") {
      let objArray = JSON.parse(res.result);
      if(objArray?.length > 0){
        let obj = objArray[0];      
        this.Digit_Insurance_VehicleCode_1 = obj?.Digit_Insurance_VehicleCode_1;
        this.Royal_Sundaram_VehicleCode_2 = obj?.Royal_Sundaram_VehicleCode_2;
        this.HDFC_ERGO_VehicleCode_3 = obj?.HDFC_ERGO_VehicleCode_3;
        this.ICICI_Lombard_VehicleCode_4 = obj?.ICICI_Lombard_VehicleCode_4;
        this.IFFCO_Tokio_VehicleCode_5 = obj?.IFFCO_Tokio_VehicleCode_5;
        this.Raheja_QBE_VehicleCode_6 = obj?.Raheja_QBE_VehicleCode_6;
        this.Reliance_General_VehicleCode_7 = obj?.Reliance_General_VehicleCode_7;
        this.Shriram_General_VehicleCode_8 = obj?.Shriram_General_VehicleCode_8;
        this.Universal_Sompo_VehicleCode_9 = obj?.Universal_Sompo_VehicleCode_9;
        this.Navi_Insurance_VehicleCode_10 = obj?.Navi_Insurance_VehicleCode_10;
        this.Bajaj_Allianz_General_VehicleCode_11 = obj?.Bajaj_Allianz_General_VehicleCode_11;
        this.National_Insurance_VehicleCode_12 = obj?.National_Insurance_VehicleCode_12;
        this.Oriental_Insurance_VehicleCode_13 = obj?.Oriental_Insurance_VehicleCode_13;
        this.Future_Generali_VehicleCode_14 = obj?.Future_Generali_VehicleCode_14;
        this.Edelweiss_General_VehicleCode_15 = obj?.Edelweiss_General_VehicleCode_15;
        this.Kotak_General_VehicleCode_16 = obj?.Kotak_General_VehicleCode_16;
        this.Liberty_General_VehicleCode_17 = obj?.Liberty_General_VehicleCode_17;
        this.Magma_HDI_VehicleCode_18 = obj?.Magma_HDI_VehicleCode_18;
        this.SBI_General_VehicleCode_19 = obj?.SBI_General_VehicleCode_19;
        this.Tata_AIG_VehicleCode_20 = obj?.Tata_AIG_VehicleCode_20;
        this.Acko_VehicleCode_21 = obj?.Acko_VehicleCode_21;
        this.Bharti_AXA_VehicleCode_22 = obj?.Bharti_AXA_VehicleCode_22;
        this.Chola_MS_VehicleCode_23 = obj?.Chola_MS_VehicleCode_23;
        this.DHFL_GI_VehicleCode_24 = obj?.DHFL_GI_VehicleCode_24;
        this.New_India_Assurance_VehicleCode_25 = obj?.New_India_Assurance_VehicleCode_25;
        this.United_India_Insurance_VehicleCode_26 = obj?.United_India_Insurance_VehicleCode_26;
        this.Zuno_Insurance_VehicleCode_27 = obj?.Zuno_Insurance_VehicleCode_27;
        this.Aditya_Birla_Health_VehicleCode_28 = obj?.Aditya_Birla_Health_VehicleCode_28;
        this.AIC_of_India_VehicleCode_29 = obj?.AIC_of_India_VehicleCode_29;
        this.Care_Health_VehicleCode_30 = obj?.Care_Health_VehicleCode_30;
        this.ManipalCigna_VehicleCode_31 = obj?.ManipalCigna_VehicleCode_31;
        this.Niva_Bupa_VehicleCode_32 = obj?.Niva_Bupa_VehicleCode_32;
        this.Star_Health_VehicleCode_33 = obj?.Star_Health_VehicleCode_33;

        this.Digit_Insurance_MappedDetails_1 = obj?.Digit_Insurance_MappedDetails_1;
        this.Royal_Sundaram_MappedDetails_2 = obj?.Royal_Sundaram_MappedDetails_2;
        this.HDFC_ERGO_MappedDetails_3 = obj?.HDFC_ERGO_MappedDetails_3;
        this.ICICI_Lombard_MappedDetails_4 = obj?.ICICI_Lombard_MappedDetails_4;
        this.IFFCO_Tokio_MappedDetails_5 = obj?.IFFCO_Tokio_MappedDetails_5;
        this.Raheja_QBE_MappedDetails_6 = obj?.Raheja_QBE_MappedDetails_6;
        this.Reliance_General_MappedDetails_7 = obj?.Reliance_General_MappedDetails_7;
        this.Shriram_General_MappedDetails_8 = obj?.Shriram_General_MappedDetails_8;
        this.Universal_Sompo_MappedDetails_9 = obj?.Universal_Sompo_MappedDetails_9;
        this.Navi_Insurance_MappedDetails_10 = obj?.Navi_Insurance_MappedDetails_10;
        this.Bajaj_Allianz_General_MappedDetails_11 = obj?.Bajaj_Allianz_General_MappedDetails_11;
        this.National_Insurance_MappedDetails_12 = obj?.National_Insurance_MappedDetails_12;
        this.Oriental_Insurance_MappedDetails_13 = obj?.Oriental_Insurance_MappedDetails_13;
        this.Future_Generali_MappedDetails_14 = obj?.Future_Generali_MappedDetails_14;
        this.Edelweiss_General_MappedDetails_15 = obj?.Edelweiss_General_MappedDetails_15;
        this.Kotak_General_MappedDetails_16 = obj?.Kotak_General_MappedDetails_16;
        this.Liberty_General_MappedDetails_17 = obj?.Liberty_General_MappedDetails_17;
        this.Magma_HDI_MappedDetails_18 = obj?.Magma_HDI_MappedDetails_18;
        this.SBI_General_MappedDetails_19 = obj?.SBI_General_MappedDetails_19;
        this.Tata_AIG_MappedDetails_20 = obj?.Tata_AIG_MappedDetails_20;
        this.Acko_MappedDetails_21 = obj?.Acko_MappedDetails_21;
        this.Bharti_AXA_MappedDetails_22 = obj?.Bharti_AXA_MappedDetails_22;
        this.Chola_MS_MappedDetails_23 = obj?.Chola_MS_MappedDetails_23;
        this.DHFL_GI_MappedDetails_24 = obj?.DHFL_GI_MappedDetails_24;
        this.New_India_Assurance_MappedDetails_25 = obj?.New_India_Assurance_MappedDetails_25;
        this.United_India_Insurance_MappedDetails_26 = obj?.United_India_Insurance_MappedDetails_26;
        this.Zuno_Insurance_MappedDetails_27 = obj?.Zuno_Insurance_MappedDetails_27;
        this.Aditya_Birla_Health_MappedDetails_28 = obj?.Aditya_Birla_Health_MappedDetails_28;
        this.AIC_of_India_MappedDetails_29 = obj?.AIC_of_India_MappedDetails_29;
        this.Care_Health_MappedDetails_30 = obj?.Care_Health_MappedDetails_30;
        this.ManipalCigna_MappedDetails_31 = obj?.ManipalCigna_MappedDetails_31;
        this.Niva_Bupa_MappedDetails_32 = obj?.Niva_Bupa_MappedDetails_32;
        this.Star_Health_MappedDetails_33 = obj?.Star_Health_MappedDetails_33;

        this.Digit_Insurance_Make_1 = obj?.Digit_Insurance_Make_1;
        this.Royal_Sundaram_Make_2 = obj?.Royal_Sundaram_Make_2;
        this.HDFC_ERGO_Make_3 = obj?.HDFC_ERGO_Make_3;
        this.ICICI_Lombard_Make_4 = obj?.ICICI_Lombard_Make_4;
        this.IFFCO_Tokio_Make_5 = obj?.IFFCO_Tokio_Make_5;
        this.Raheja_QBE_Make_6 = obj?.Raheja_QBE_Make_6;
        this.Reliance_General_Make_7 = obj?.Reliance_General_Make_7;
        this.Shriram_General_Make_8 = obj?.Shriram_General_Make_8;
        this.Universal_Sompo_Make_9 = obj?.Universal_Sompo_Make_9;
        this.Navi_Insurance_Make_10 = obj?.Navi_Insurance_Make_10;
        this.Bajaj_Allianz_General_Make_11 = obj?.Bajaj_Allianz_General_Make_11;
        this.National_Insurance_Make_12 = obj?.National_Insurance_Make_12;
        this.Oriental_Insurance_Make_13 = obj?.Oriental_Insurance_Make_13;
        this.Future_Generali_Make_14 = obj?.Future_Generali_Make_14;
        this.Edelweiss_General_Make_15 = obj?.Edelweiss_General_Make_15;
        this.Kotak_General_Make_16 = obj?.Kotak_General_Make_16;
        this.Liberty_General_Make_17 = obj?.Liberty_General_Make_17;
        this.Magma_HDI_Make_18 = obj?.Magma_HDI_Make_18;
        this.SBI_General_Make_19 = obj?.SBI_General_Make_19;
        this.Tata_AIG_Make_20 = obj?.Tata_AIG_Make_20;
        this.Acko_Make_21 = obj?.Acko_Make_21;
        this.Bharti_AXA_Make_22 = obj?.Bharti_AXA_Make_22;
        this.Chola_MS_Make_23 = obj?.Chola_MS_Make_23;
        this.DHFL_GI_Make_24 = obj?.DHFL_GI_Make_24;
        this.New_India_Assurance_Make_25 = obj?.New_India_Assurance_Make_25;
        this.United_India_Insurance_Make_26 = obj?.United_India_Insurance_Make_26;
        this.Zuno_Insurance_Make_27 = obj?.Zuno_Insurance_Make_27;
        this.Aditya_Birla_Health_Make_28 = obj?.Aditya_Birla_Health_Make_28;
        this.AIC_of_India_Make_29 = obj?.AIC_of_India_Make_29;
        this.Care_Health_Make_30 = obj?.Care_Health_Make_30;
        this.ManipalCigna_Make_31 = obj?.ManipalCigna_Make_31;
        this.Niva_Bupa_Make_32 = obj?.Niva_Bupa_Make_32;
        this.Star_Health_Make_33 = obj?.Star_Health_Make_33;

        if (this.Digit_Insurance_1_MakeList?.length > 0 && (this.Digit_Insurance_Make_1 ?? "") !== "") {
          this.Digit_Insurance_1_MakeList = this.Digit_Insurance_1_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Digit_Insurance_Make_1?.trim()
          }));
          this.loadModelListIns(this.Digit_Insurance_Make_1?.trim(), 1, this.Digit_Insurance_VehicleCode_1);
        }

        if (this.Royal_Sundaram_2_MakeList?.length > 0 && (this.Royal_Sundaram_Make_2 ?? "") !== "") {
          this.Royal_Sundaram_2_MakeList = this.Royal_Sundaram_2_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Royal_Sundaram_Make_2?.trim()
          }));
          this.loadModelListIns(this.Royal_Sundaram_Make_2?.trim(), 2, this.Royal_Sundaram_VehicleCode_2);
        }

        if (this.HDFC_ERGO_3_MakeList?.length > 0 && (this.HDFC_ERGO_Make_3 ?? "") !== "") {
          this.HDFC_ERGO_3_MakeList = this.HDFC_ERGO_3_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.HDFC_ERGO_Make_3?.trim()
          }));
          this.loadModelListIns(this.HDFC_ERGO_Make_3?.trim(), 3, this.HDFC_ERGO_VehicleCode_3);
        }

        if (this.ICICI_Lombard_4_MakeList?.length > 0 && (this.ICICI_Lombard_Make_4 ?? "") !== "") {
          this.ICICI_Lombard_4_MakeList = this.ICICI_Lombard_4_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.ICICI_Lombard_Make_4?.trim()
          }));
          this.loadModelListIns(this.ICICI_Lombard_Make_4?.trim(), 4, this.ICICI_Lombard_VehicleCode_4);
        }

        if (this.IFFCO_Tokio_5_MakeList?.length > 0 && (this.IFFCO_Tokio_Make_5 ?? "") !== "") {
          this.IFFCO_Tokio_5_MakeList = this.IFFCO_Tokio_5_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.IFFCO_Tokio_Make_5?.trim()
          }));
          this.loadModelListIns(this.IFFCO_Tokio_Make_5?.trim(), 5, this.IFFCO_Tokio_VehicleCode_5);
        }

        if (this.Raheja_QBE_6_MakeList?.length > 0 && (this.Raheja_QBE_Make_6 ?? "") !== "") {
          this.Raheja_QBE_6_MakeList = this.Raheja_QBE_6_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Raheja_QBE_Make_6?.trim()
          }));
          this.loadModelListIns(this.Raheja_QBE_Make_6?.trim(), 6, this.Raheja_QBE_VehicleCode_6);
        }

        if (this.Reliance_General_7_MakeList?.length > 0 && (this.Reliance_General_Make_7 ?? "") !== "") {
          this.Reliance_General_7_MakeList = this.Reliance_General_7_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Reliance_General_Make_7?.trim()
          }));
          this.loadModelListIns(this.Reliance_General_Make_7?.trim(), 7, this.Reliance_General_VehicleCode_7);
        }

        if (this.Shriram_General_8_MakeList?.length > 0 && (this.Shriram_General_Make_8 ?? "") !== "") {
          this.Shriram_General_8_MakeList = this.Shriram_General_8_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Shriram_General_Make_8?.trim()
          }));
          this.loadModelListIns(this.Shriram_General_Make_8?.trim(), 8, this.Shriram_General_VehicleCode_8);
        }

        if (this.Universal_Sompo_9_MakeList?.length > 0 && (this.Universal_Sompo_Make_9 ?? "") !== "") {
          this.Universal_Sompo_9_MakeList = this.Universal_Sompo_9_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Universal_Sompo_Make_9?.trim()
          }));
          this.loadModelListIns(this.Universal_Sompo_Make_9?.trim(), 9, this.Universal_Sompo_VehicleCode_9);
        }

        if (this.Navi_Insurance_10_MakeList?.length > 0 && (this.Navi_Insurance_Make_10 ?? "") !== "") {
          this.Navi_Insurance_10_MakeList = this.Navi_Insurance_10_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Navi_Insurance_Make_10?.trim()
          }));
          this.loadModelListIns(this.Navi_Insurance_Make_10?.trim(), 10, this.Navi_Insurance_VehicleCode_10);
        }

        if (this.Bajaj_Allianz_General_11_MakeList?.length > 0 && (this.Bajaj_Allianz_General_Make_11 ?? "") !== "") {
          this.Bajaj_Allianz_General_11_MakeList = this.Bajaj_Allianz_General_11_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Bajaj_Allianz_General_Make_11?.trim()
          }));
          this.loadModelListIns(this.Bajaj_Allianz_General_Make_11?.trim(), 11, this.Bajaj_Allianz_General_VehicleCode_11);
        }

        if (this.National_Insurance_12_MakeList?.length > 0 && (this.National_Insurance_Make_12 ?? "") !== "") {
          this.National_Insurance_12_MakeList = this.National_Insurance_12_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.National_Insurance_Make_12?.trim()
          }));
          this.loadModelListIns(this.National_Insurance_Make_12?.trim(), 12, this.National_Insurance_VehicleCode_12);
        }

        if (this.Oriental_Insurance_13_MakeList?.length > 0 && (this.Oriental_Insurance_Make_13 ?? "") !== "") {
          this.Oriental_Insurance_13_MakeList = this.Oriental_Insurance_13_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Oriental_Insurance_Make_13?.trim()
          }));
          this.loadModelListIns(this.Oriental_Insurance_Make_13?.trim(), 13, this.Oriental_Insurance_VehicleCode_13);
        }

        if (this.Future_Generali_14_MakeList?.length > 0 && (this.Future_Generali_Make_14 ?? "") !== "") {
          this.Future_Generali_14_MakeList = this.Future_Generali_14_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Future_Generali_Make_14?.trim()
          }));
          this.loadModelListIns(this.Future_Generali_Make_14?.trim(), 14, this.Future_Generali_VehicleCode_14);
        }

        if (this.Edelweiss_General_15_MakeList?.length > 0 && (this.Edelweiss_General_Make_15 ?? "") !== "") {
          this.Edelweiss_General_15_MakeList = this.Edelweiss_General_15_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Edelweiss_General_Make_15?.trim()
          }));
          this.loadModelListIns(this.Edelweiss_General_Make_15?.trim(), 15, this.Edelweiss_General_VehicleCode_15);
        }

        if (this.Kotak_General_16_MakeList?.length > 0 && (this.Kotak_General_Make_16 ?? "") !== "") {
          this.Kotak_General_16_MakeList = this.Kotak_General_16_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Kotak_General_Make_16?.trim()
          }));
          this.loadModelListIns(this.Kotak_General_Make_16?.trim(), 16, this.Kotak_General_VehicleCode_16);
        }

        if (this.Liberty_General_17_MakeList?.length > 0 && (this.Liberty_General_Make_17 ?? "") !== "") {
          this.Liberty_General_17_MakeList = this.Liberty_General_17_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Liberty_General_Make_17?.trim()
          }));
          this.loadModelListIns(this.Liberty_General_Make_17?.trim(), 17, this.Liberty_General_VehicleCode_17);
        }

        if (this.Magma_HDI_18_MakeList?.length > 0 && (this.Magma_HDI_Make_18 ?? "") !== "") {
          this.Magma_HDI_18_MakeList = this.Magma_HDI_18_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Magma_HDI_Make_18?.trim()
          }));
          this.loadModelListIns(this.Magma_HDI_Make_18?.trim(), 18, this.Magma_HDI_VehicleCode_18);
        }

        if (this.SBI_General_19_MakeList?.length > 0 && (this.SBI_General_Make_19 ?? "") !== "") {
          this.SBI_General_19_MakeList = this.SBI_General_19_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.SBI_General_Make_19?.trim()
          }));
          this.loadModelListIns(this.SBI_General_Make_19?.trim(), 19, this.SBI_General_VehicleCode_19);
        }

        if (this.Tata_AIG_20_MakeList?.length > 0 && (this.Tata_AIG_Make_20 ?? "") !== "") {
          this.Tata_AIG_20_MakeList = this.Tata_AIG_20_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Tata_AIG_Make_20?.trim()
          }));
          this.loadModelListIns(this.Tata_AIG_Make_20?.trim(), 20, this.Tata_AIG_VehicleCode_20);
        }

        if (this.Acko_21_MakeList?.length > 0 && (this.Acko_Make_21 ?? "") !== "") {
          this.Acko_21_MakeList = this.Acko_21_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Acko_Make_21?.trim()
          }));
          this.loadModelListIns(this.Acko_Make_21?.trim(), 21, this.Acko_VehicleCode_21);
        }

        if (this.Bharti_AXA_22_MakeList?.length > 0 && (this.Bharti_AXA_Make_22 ?? "") !== "") {
          this.Bharti_AXA_22_MakeList = this.Bharti_AXA_22_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Bharti_AXA_Make_22?.trim()
          }));
          this.loadModelListIns(this.Bharti_AXA_Make_22?.trim(), 22, this.Bharti_AXA_VehicleCode_22);
        }

        if (this.Chola_MS_23_MakeList?.length > 0 && (this.Chola_MS_Make_23 ?? "") !== "") {
          this.Chola_MS_23_MakeList = this.Chola_MS_23_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Chola_MS_Make_23?.trim()
          }));
          this.loadModelListIns(this.Chola_MS_Make_23?.trim(), 23, this.Chola_MS_VehicleCode_23);
        }

        if (this.DHFL_GI_24_MakeList?.length > 0 && (this.DHFL_GI_Make_24 ?? "") !== "") {
          this.DHFL_GI_24_MakeList = this.DHFL_GI_24_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.DHFL_GI_Make_24?.trim()
          }));
          this.loadModelListIns(this.DHFL_GI_Make_24?.trim(), 24, this.DHFL_GI_VehicleCode_24);
        }

        if (this.New_India_Assurance_25_MakeList?.length > 0 && (this.New_India_Assurance_Make_25 ?? "") !== "") {
          this.New_India_Assurance_25_MakeList = this.New_India_Assurance_25_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.New_India_Assurance_Make_25?.trim()
          }));
          this.loadModelListIns(this.New_India_Assurance_Make_25?.trim(), 25, this.New_India_Assurance_VehicleCode_25);
        }

        if (this.United_India_Insurance_26_MakeList?.length > 0 && (this.United_India_Insurance_Make_26 ?? "") !== "") {
          this.United_India_Insurance_26_MakeList = this.United_India_Insurance_26_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.United_India_Insurance_Make_26?.trim()
          }));
          this.loadModelListIns(this.United_India_Insurance_Make_26?.trim(), 26, this.United_India_Insurance_VehicleCode_26);
        }

        if (this.Zuno_Insurance_27_MakeList?.length > 0 && (this.Zuno_Insurance_Make_27 ?? "") !== "") {
          this.Zuno_Insurance_27_MakeList = this.Zuno_Insurance_27_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Zuno_Insurance_Make_27?.trim()
          }));
          this.loadModelListIns(this.Zuno_Insurance_Make_27?.trim(), 27, this.Zuno_Insurance_VehicleCode_27);
        }

        if (this.Aditya_Birla_Health_28_MakeList?.length > 0 && (this.Aditya_Birla_Health_Make_28 ?? "") !== "") {
          this.Aditya_Birla_Health_28_MakeList = this.Aditya_Birla_Health_28_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Aditya_Birla_Health_Make_28?.trim()
          }));
          this.loadModelListIns(this.Aditya_Birla_Health_Make_28?.trim(), 28, this.Aditya_Birla_Health_VehicleCode_28);
        }

        if (this.AIC_of_India_29_MakeList?.length > 0 && (this.AIC_of_India_Make_29 ?? "") !== "") {
          this.AIC_of_India_29_MakeList = this.AIC_of_India_29_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.AIC_of_India_Make_29?.trim()
          }));
          this.loadModelListIns(this.AIC_of_India_Make_29?.trim(), 29, this.AIC_of_India_VehicleCode_29);
        }

        if (this.Care_Health_30_MakeList?.length > 0 && (this.Care_Health_Make_30 ?? "") !== "") {
          this.Care_Health_30_MakeList = this.Care_Health_30_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Care_Health_Make_30?.trim()
          }));
          this.loadModelListIns(this.Care_Health_Make_30?.trim(), 30, this.Care_Health_VehicleCode_30);
        }

        if (this.ManipalCigna_31_MakeList?.length > 0 && (this.ManipalCigna_Make_31 ?? "") !== "") {
          this.ManipalCigna_31_MakeList = this.ManipalCigna_31_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.ManipalCigna_Make_31?.trim()
          }));
          this.loadModelListIns(this.ManipalCigna_Make_31?.trim(), 31, this.ManipalCigna_VehicleCode_31);
        }

        if (this.Niva_Bupa_32_MakeList?.length > 0 && (this.Niva_Bupa_Make_32 ?? "") !== "") {
          this.Niva_Bupa_32_MakeList = this.Niva_Bupa_32_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Niva_Bupa_Make_32?.trim()
          }));
          this.loadModelListIns(this.Niva_Bupa_Make_32?.trim(), 32, this.Niva_Bupa_VehicleCode_32);
        }

        if (this.Star_Health_33_MakeList?.length > 0 && (this.Star_Health_Make_33 ?? "") !== "") {
          this.Star_Health_33_MakeList = this.Star_Health_33_MakeList.map((m: Item) => ({
            ...m, checked: m.name?.trim() === this.Star_Health_Make_33?.trim()
          }));
          this.loadModelListIns(this.Star_Health_Make_33?.trim(), 33, this.Star_Health_VehicleCode_33);
        }
      }
    }
    else
    {
      this.resetMappingField();
    }
  }

  resetMappingField(){
    this.Digit_Insurance_VehicleCode_1 = "";
    this.Royal_Sundaram_VehicleCode_2 = "";
    this.HDFC_ERGO_VehicleCode_3 = "";
    this.ICICI_Lombard_VehicleCode_4 = "";
    this.IFFCO_Tokio_VehicleCode_5 = "";
    this.Raheja_QBE_VehicleCode_6 = "";
    this.Reliance_General_VehicleCode_7 = "";
    this.Shriram_General_VehicleCode_8 = "";
    this.Universal_Sompo_VehicleCode_9 = "";
    this.Navi_Insurance_VehicleCode_10 = "";
    this.Bajaj_Allianz_General_VehicleCode_11 = "";
    this.National_Insurance_VehicleCode_12 = "";
    this.Oriental_Insurance_VehicleCode_13 = "";
    this.Future_Generali_VehicleCode_14 = "";
    this.Edelweiss_General_VehicleCode_15 = "";
    this.Kotak_General_VehicleCode_16 = "";
    this.Liberty_General_VehicleCode_17 = "";
    this.Magma_HDI_VehicleCode_18 = "";
    this.SBI_General_VehicleCode_19 = "";
    this.Tata_AIG_VehicleCode_20 = "";
    this.Acko_VehicleCode_21 = "";
    this.Bharti_AXA_VehicleCode_22 = "";
    this.Chola_MS_VehicleCode_23 = "";
    this.DHFL_GI_VehicleCode_24 = "";
    this.New_India_Assurance_VehicleCode_25 = "";
    this.United_India_Insurance_VehicleCode_26 = "";
    this.Zuno_Insurance_VehicleCode_27 = "";
    this.Aditya_Birla_Health_VehicleCode_28 = "";
    this.AIC_of_India_VehicleCode_29 = "";
    this.Care_Health_VehicleCode_30 = "";
    this.ManipalCigna_VehicleCode_31 = "";
    this.Niva_Bupa_VehicleCode_32 = "";
    this.Star_Health_VehicleCode_33 = "";

    this.Digit_Insurance_MappedDetails_1 = "";
    this.Royal_Sundaram_MappedDetails_2 = "";
    this.HDFC_ERGO_MappedDetails_3 = "";
    this.ICICI_Lombard_MappedDetails_4 = "";
    this.IFFCO_Tokio_MappedDetails_5 = "";
    this.Raheja_QBE_MappedDetails_6 = "";
    this.Reliance_General_MappedDetails_7 = "";
    this.Shriram_General_MappedDetails_8 = "";
    this.Universal_Sompo_MappedDetails_9 = "";
    this.Navi_Insurance_MappedDetails_10 = "";
    this.Bajaj_Allianz_General_MappedDetails_11 = "";
    this.National_Insurance_MappedDetails_12 = "";
    this.Oriental_Insurance_MappedDetails_13 = "";
    this.Future_Generali_MappedDetails_14 = "";
    this.Edelweiss_General_MappedDetails_15 = "";
    this.Kotak_General_MappedDetails_16 = "";
    this.Liberty_General_MappedDetails_17 = "";
    this.Magma_HDI_MappedDetails_18 = "";
    this.SBI_General_MappedDetails_19 = "";
    this.Tata_AIG_MappedDetails_20 = "";
    this.Acko_MappedDetails_21 = "";
    this.Bharti_AXA_MappedDetails_22 = "";
    this.Chola_MS_MappedDetails_23 = "";
    this.DHFL_GI_MappedDetails_24 = "";
    this.New_India_Assurance_MappedDetails_25 = "";
    this.United_India_Insurance_MappedDetails_26 = "";
    this.Zuno_Insurance_MappedDetails_27 = "";
    this.Aditya_Birla_Health_MappedDetails_28 = "";
    this.AIC_of_India_MappedDetails_29 = "";
    this.Care_Health_MappedDetails_30 = "";
    this.ManipalCigna_MappedDetails_31 = "";
    this.Niva_Bupa_MappedDetails_32 = "";
    this.Star_Health_MappedDetails_33 = "";
  }
  
  async loadActiveInsuranceCompanies() {
    let res = await this.lookUpService.GetActiveInsuranceProducts(this.vehicleType);
    if (res != null && res.isSuccess && res.result) {
      this.activeInsuranceCompanyList = res.result;//?.map((m: any) => { return { text: m, value: m } });
      let selectedIds = this.activeInsuranceCompanyList?.map((m: any) => { return m?.id });
      for (let i = 0; i < selectedIds.length; i++) {
        await this.loadMakeListIns(selectedIds[i]);
      }


      // this.Digit_Insurance_1 = selectedIds?.includes(1);
      // this.Royal_Sundaram_2 = selectedIds?.includes(2);
      // this.HDFC_ERGO_3 = selectedIds?.includes(3);
      // this.ICICI_Lombard_4 = selectedIds?.includes(4);
      // this.IFFCO_Tokio_5 = selectedIds?.includes(5);
      // this.Raheja_QBE_6 = selectedIds?.includes(6);
      // this.Reliance_General_7 = selectedIds?.includes(7);
      // this.Shriram_General_8 = selectedIds?.includes(8);
      // this.Universal_Sompo_9 = selectedIds?.includes(9);
      // this.Navi_Insurance_10 = selectedIds?.includes(10);
      // this.Bajaj_Allianz_General_11 = selectedIds?.includes(11);
      // this.National_Insurance_12 = selectedIds?.includes(12);
      // this.Oriental_Insurance_13 = selectedIds?.includes(13);
      // this.Future_Generali_14 = selectedIds?.includes(14);
      // this.Edelweiss_General_15 = selectedIds?.includes(15);
      // this.Kotak_General_16 = selectedIds?.includes(16);
      // this.Liberty_General_17 = selectedIds?.includes(17);
      // this.Magma_HDI_18 = selectedIds?.includes(18);
      // this.SBI_General_19 = selectedIds?.includes(19);
      // this.Tata_AIG_20 = selectedIds?.includes(20);
      // this.Acko_21 = selectedIds?.includes(21);
      // this.Bharti_AXA_22 = selectedIds?.includes(22);
      // this.Chola_MS_23 = selectedIds?.includes(23);
      // this.DHFL_GI_24 = selectedIds?.includes(24);
      // this.New_India_Assurance_25 = selectedIds?.includes(25);
      // this.United_India_Insurance_26 = selectedIds?.includes(26);
      // this.Zuno_Insurance_27 = selectedIds?.includes(27);
      // this.Aditya_Birla_Health_28 = selectedIds?.includes(28);
      // this.AIC_of_India_29 = selectedIds?.includes(29);
      // this.Care_Health_30 = selectedIds?.includes(30);
      // this.ManipalCigna_31 = selectedIds?.includes(31);
      // this.Niva_Bupa_32 = selectedIds?.includes(32);
      // this.Star_Health_33 = selectedIds?.includes(33);

    }
  }

  togglePanel(id: any) {
    this.activePanel = id;
  }


  onMakeSelectIns(data: Item[], insId: number) {
    let selectedMakes = data.map((m: Item) => { return m.id }).toString();
    if (selectedMakes != "")
      this.loadModelListIns(selectedMakes, insId);
  }

  onModelSelectIns(data: Item[], insId: number) {
    let selectedModelId = data.map((m: Item) => { return m.id }).toString();
    let selectedModelDetails = data.map((m: Item) => { return m.name }).toString();
    let selectedMake = data.map((m: Item) => { return m.name2 }).toString();
    this.setMappingData(insId,selectedModelId,selectedModelDetails,selectedMake??"");    
  }

  setMappingData(insId:number,selectedModelId:string,selectedModelDetails:string,selectedMake:string = ""){
    switch (insId) {
      case 1:
        this.Digit_Insurance_VehicleCode_1 = selectedModelId;
        this.Digit_Insurance_MappedDetails_1 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
        break;

      case 2:
          this.Royal_Sundaram_VehicleCode_2 = selectedModelId;
          this.Royal_Sundaram_MappedDetails_2 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 3:
          this.HDFC_ERGO_VehicleCode_3 = selectedModelId;
          this.HDFC_ERGO_MappedDetails_3 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 4:
          this.ICICI_Lombard_VehicleCode_4 = selectedModelId;
          this.ICICI_Lombard_MappedDetails_4 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 5:
          this.IFFCO_Tokio_VehicleCode_5 = selectedModelId;
          this.IFFCO_Tokio_MappedDetails_5 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 6:
          this.Raheja_QBE_VehicleCode_6 = selectedModelId;
          this.Raheja_QBE_MappedDetails_6 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 7:
          this.Reliance_General_VehicleCode_7 = selectedModelId;
          this.Reliance_General_MappedDetails_7 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 8:
          this.Shriram_General_VehicleCode_8 = selectedModelId;
          this.Shriram_General_MappedDetails_8 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 9:
          this.Universal_Sompo_VehicleCode_9 = selectedModelId;
          this.Universal_Sompo_MappedDetails_9 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 10:
          this.Navi_Insurance_VehicleCode_10 = selectedModelId;
          this.Navi_Insurance_MappedDetails_10 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 11:
          this.Bajaj_Allianz_General_VehicleCode_11 = selectedModelId;
          this.Bajaj_Allianz_General_MappedDetails_11 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 12:
          this.National_Insurance_VehicleCode_12 = selectedModelId;
          this.National_Insurance_MappedDetails_12 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 13:
          this.Oriental_Insurance_VehicleCode_13 = selectedModelId;
          this.Oriental_Insurance_MappedDetails_13 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 14:
          this.Future_Generali_VehicleCode_14 = selectedModelId;
          this.Future_Generali_MappedDetails_14 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 15:
          this.Edelweiss_General_VehicleCode_15 = selectedModelId;
          this.Edelweiss_General_MappedDetails_15 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 16:
          this.Kotak_General_VehicleCode_16 = selectedModelId;
          this.Kotak_General_MappedDetails_16 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 17:
          this.Liberty_General_VehicleCode_17 = selectedModelId;
          this.Liberty_General_MappedDetails_17 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 18:
          this.Magma_HDI_VehicleCode_18 = selectedModelId;
          this.Magma_HDI_MappedDetails_18 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 19:
          this.SBI_General_VehicleCode_19 = selectedModelId;
          this.SBI_General_MappedDetails_19 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 20:
          this.Tata_AIG_VehicleCode_20 = selectedModelId;
          this.Tata_AIG_MappedDetails_20 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 21:
          this.Acko_VehicleCode_21 = selectedModelId;
          this.Acko_MappedDetails_21 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 22:
          this.Bharti_AXA_VehicleCode_22 = selectedModelId;
          this.Bharti_AXA_MappedDetails_22 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 23:
          this.Chola_MS_VehicleCode_23 = selectedModelId;
          this.Chola_MS_MappedDetails_23 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 24:
          this.DHFL_GI_VehicleCode_24 = selectedModelId;
          this.DHFL_GI_MappedDetails_24 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 25:
          this.New_India_Assurance_VehicleCode_25 = selectedModelId;
          this.New_India_Assurance_MappedDetails_25 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 26:
          this.United_India_Insurance_VehicleCode_26 = selectedModelId;
          this.United_India_Insurance_MappedDetails_26 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 27:
          this.Zuno_Insurance_VehicleCode_27 = selectedModelId;
          this.Zuno_Insurance_MappedDetails_27 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 28:
          this.Aditya_Birla_Health_VehicleCode_28 = selectedModelId;
          this.Aditya_Birla_Health_MappedDetails_28 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 29:
          this.AIC_of_India_VehicleCode_29 = selectedModelId;
          this.AIC_of_India_MappedDetails_29 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 30:
          this.Care_Health_VehicleCode_30 = selectedModelId;
          this.Care_Health_MappedDetails_30 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 31:
          this.ManipalCigna_VehicleCode_31 = selectedModelId;
          this.ManipalCigna_MappedDetails_31 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 32:
          this.Niva_Bupa_VehicleCode_32 = selectedModelId;
          this.Niva_Bupa_MappedDetails_32 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;

      case 33:
          this.Star_Health_VehicleCode_33 = selectedModelId;
          this.Star_Health_MappedDetails_33 = selectedMake != "" ? (selectedMake + ' | ' + selectedModelDetails) : selectedModelDetails;
          break;
    }
  }

  async loadModelListIns(selectedMakes: string, insId: number, selectedModelVariant:string = "") {
    let obj = {
      type: this.vehicleType,
      fuel: this.fuelType,
      companyName: selectedMakes,
      vehicleCategory: this.vehicleCategory,
      insuranceCompany: insId
    }
    let res = await this.lookUpService.GetVehicleModelVariantByFuelCategoryMake(obj);
    if (res != null && res.isSuccess && res.result) {
      let modelList = res.result.map((m: any) => {
        return {
          name: (m.modelName?.trim() + ' ' + m.variantName?.trim() + (this.vehicleType < 3 || (this.vehicleType == 3 && this.vehicleCategory == "Passenger Carrying") ? ' | ' + m.cubicCapacity?.trim() + ' CC' : ' | GVW - ' + m.gvw?.trim()) + ' | Seating Capacity - ' + m.seatingCapacity?.trim() + ' | Body Type - ' + m.bodyType?.trim() + ' | ' + m.vehicleCode?.trim()),
          id: m.vehicleCode?.trim(),
          name1: '',
          name2: selectedMakes,
          checked: selectedModelVariant?.trim() == m.vehicleCode?.trim()
        }
      });
        switch (insId) {
          case 1:
            this.Digit_Insurance_1_ModelList = modelList;
            break;
          case 2:
            this.Royal_Sundaram_2_ModelList = modelList;
            break;
          case 3:
            this.HDFC_ERGO_3_ModelList = modelList;
            break;
          case 4:
            this.ICICI_Lombard_4_ModelList = modelList;
            break;
          case 5:
            this.IFFCO_Tokio_5_ModelList = modelList;
            break;
          case 6:
            this.Raheja_QBE_6_ModelList = modelList;
            break;
          case 7:
            this.Reliance_General_7_ModelList = modelList;
            break;
          case 8:
            this.Shriram_General_8_ModelList = modelList;
            break;
          case 9:
            this.Universal_Sompo_9_ModelList = modelList;
            break;
          case 10:
            this.Navi_Insurance_10_ModelList = modelList;
            break;
          case 11:
            this.Bajaj_Allianz_General_11_ModelList = modelList;
            break;
          case 12:
            this.National_Insurance_12_ModelList = modelList;
            break;
          case 13:
            this.Oriental_Insurance_13_ModelList = modelList;
            break;
          case 14:
            this.Future_Generali_14_ModelList = modelList;
            break;
          case 15:
            this.Edelweiss_General_15_ModelList = modelList;
            break;
          case 16:
            this.Kotak_General_16_ModelList = modelList;
            break;
          case 17:
            this.Liberty_General_17_ModelList = modelList;
            break;
          case 18:
            this.Magma_HDI_18_ModelList = modelList;
            break;
          case 19:
            this.SBI_General_19_ModelList = modelList;
            break;
          case 20:
            this.Tata_AIG_20_ModelList = modelList;
            break;
          case 21:
            this.Acko_21_ModelList = modelList;
            break;
          case 22:
            this.Bharti_AXA_22_ModelList = modelList;
            break;
          case 23:
            this.Chola_MS_23_ModelList = modelList;
            break;
          case 24:
            this.DHFL_GI_24_ModelList = modelList;
            break;
          case 25:
            this.New_India_Assurance_25_ModelList = modelList;
            break;
          case 26:
            this.United_India_Insurance_26_ModelList = modelList;
            break;
          case 27:
            this.Zuno_Insurance_27_ModelList = modelList;
            break;
          case 28:
            this.Aditya_Birla_Health_28_ModelList = modelList;
            break;
          case 29:
            this.AIC_of_India_29_ModelList = modelList;
            break;
          case 30:
            this.Care_Health_30_ModelList = modelList;
            break;
          case 31:
            this.ManipalCigna_31_ModelList = modelList;
            break;
          case 32:
            this.Niva_Bupa_32_ModelList = modelList;
            break;
          case 33:
            this.Star_Health_33_ModelList = modelList;
            break;
        }
    }
  }

  async loadMakeListIns(insId: number) {
    let data: never[] = [];
    let obj = {
      type: this.vehicleType,
      fuel: this.fuelType,
      vehicleCategory: this.vehicleCategory,
      insuranceCompany: insId
    };
    let res = await this.lookUpService.GetVehicleMakeByFuelCategory(obj);
      if (res != null && res.isSuccess && res.result) {
        data = res.result.map((m: any) => { return { name: m, id: m, checked: false }});
        //this.fuelTypeList.unshift({text : "Select Fuel Type", value : ""});
        switch (insId) {
          case 1:
            this.Digit_Insurance_1 = true;
            this.Digit_Insurance_1_MakeList = data;
            break;
          case 2:
            this.Royal_Sundaram_2 = true;
            this.Royal_Sundaram_2_MakeList = data;
            break;
          case 3:
            this.HDFC_ERGO_3 = true;
            this.HDFC_ERGO_3_MakeList = data;
            break;
          case 4:
            this.ICICI_Lombard_4 = true;
            this.ICICI_Lombard_4_MakeList = data;
            break;
          case 5:
            this.IFFCO_Tokio_5 = true;
            this.IFFCO_Tokio_5_MakeList = data;
            break;
          case 6:
            this.Raheja_QBE_6 = true;
            this.Raheja_QBE_6_MakeList = data;
            break;
          case 7:
            this.Reliance_General_7 = true;
            this.Reliance_General_7_MakeList = data;
            break;
          case 8:
            this.Shriram_General_8 = true;
            this.Shriram_General_8_MakeList = data;
            break;
          case 9:
            this.Universal_Sompo_9 = true;
            this.Universal_Sompo_9_MakeList = data;
            break;
          case 10:
            this.Navi_Insurance_10 = true;
            this.Navi_Insurance_10_MakeList = data;
            break;
          case 11:
            this.Bajaj_Allianz_General_11 = true;
            this.Bajaj_Allianz_General_11_MakeList = data;
            break;
          case 12:
            this.National_Insurance_12 = true;
            this.National_Insurance_12_MakeList = data;
            break;
          case 13:
            this.Oriental_Insurance_13 = true;
            this.Oriental_Insurance_13_MakeList = data;
            break;
          case 14:
            this.Future_Generali_14 = true;
            this.Future_Generali_14_MakeList = data;
            break;
          case 15:
            this.Edelweiss_General_15 = true;
            this.Edelweiss_General_15_MakeList = data;
            break;
          case 16:
            this.Kotak_General_16 = true;
            this.Kotak_General_16_MakeList = data;
            break;
          case 17:
            this.Liberty_General_17 = true;
            this.Liberty_General_17_MakeList = data;
            break;
          case 18:
            this.Magma_HDI_18 = true;
            this.Magma_HDI_18_MakeList = data;
            break;
          case 19:
            this.SBI_General_19 = true;
            this.SBI_General_19_MakeList = data;
            break;
          case 20:
            this.Tata_AIG_20 = true;
            this.Tata_AIG_20_MakeList = data;
            break;
          case 21:
            this.Acko_21 = true;
            this.Acko_21_MakeList = data;
            break;
          case 22:
            this.Bharti_AXA_22 = true;
            this.Bharti_AXA_22_MakeList = data;
            break;
          case 23:
            this.Chola_MS_23 = true;
            this.Chola_MS_23_MakeList = data;
            break;
          case 24:
            this.DHFL_GI_24 = true;
            this.DHFL_GI_24_MakeList = data;
            break;
          case 25:
            this.New_India_Assurance_25 = true;
            this.New_India_Assurance_25_MakeList = data;
            break;
          case 26:
            this.United_India_Insurance_26 = true;
            this.United_India_Insurance_26_MakeList = data;
            break;
          case 27:
            this.Zuno_Insurance_27 = true;
            this.Zuno_Insurance_27_MakeList = data;
            break;
          case 28:
            this.Aditya_Birla_Health_28 = true;
            this.Aditya_Birla_Health_28_MakeList = data;
            break;
          case 29:
            this.AIC_of_India_29 = true;
            this.AIC_of_India_29_MakeList = data;
            break;
          case 30:
            this.Care_Health_30 = true;
            this.Care_Health_30_MakeList = data;
            break;
          case 31:
            this.ManipalCigna_31 = true;
            this.ManipalCigna_31_MakeList = data;
            break;
          case 32:
            this.Niva_Bupa_32 = true;
            this.Niva_Bupa_32_MakeList = data;
            break;
          case 33:
            this.Star_Health_33 = true;
            this.Star_Health_33_MakeList = data;
            break;
        }
      }
  }

  async UpdateMapping(){
    let obj = {
      "vehicleCodeId": this.selectedModels,
      "digit_Insurance_VehicleCode_1": this.Digit_Insurance_VehicleCode_1,
      "royal_Sundaram_VehicleCode_2": this.Royal_Sundaram_VehicleCode_2,
      "hdfC_ERGO_VehicleCode_3": this.HDFC_ERGO_VehicleCode_3,
      "icicI_Lombard_VehicleCode_4": this.ICICI_Lombard_VehicleCode_4,
      "iffcO_Tokio_VehicleCode_5": this.IFFCO_Tokio_VehicleCode_5,
      "raheja_QBE_VehicleCode_6": this.Raheja_QBE_VehicleCode_6,
      "reliance_General_VehicleCode_7": this.Reliance_General_VehicleCode_7,
      "shriram_General_VehicleCode_8": this.Shriram_General_VehicleCode_8,
      "universal_Sompo_VehicleCode_9": this.Universal_Sompo_VehicleCode_9,
      "navi_Insurance_VehicleCode_10": this.Navi_Insurance_VehicleCode_10,
      "bajaj_Allianz_General_VehicleCode_11": this.Bajaj_Allianz_General_VehicleCode_11,
      "national_Insurance_VehicleCode_12": this.National_Insurance_VehicleCode_12,
      "oriental_Insurance_VehicleCode_13": this.Oriental_Insurance_VehicleCode_13,
      "future_Generali_VehicleCode_14": this.Future_Generali_VehicleCode_14,
      "edelweiss_General_VehicleCode_15": this.Edelweiss_General_VehicleCode_15,
      "kotak_General_VehicleCode_16": this.Kotak_General_VehicleCode_16,
      "liberty_General_VehicleCode_17": this.Liberty_General_VehicleCode_17,
      "magma_HDI_VehicleCode_18": this.Magma_HDI_VehicleCode_18,
      "sbI_General_VehicleCode_19": this.SBI_General_VehicleCode_19,
      "tata_AIG_VehicleCode_20": this.Tata_AIG_VehicleCode_20,
      "acko_VehicleCode_21": this.Acko_VehicleCode_21,
      "bharti_AXA_VehicleCode_22": this.Bharti_AXA_VehicleCode_22,
      "chola_MS_VehicleCode_23": this.Chola_MS_VehicleCode_23,
      "dhfL_GI_VehicleCode_24": this.DHFL_GI_VehicleCode_24,
      "new_India_Assurance_VehicleCode_25": this.New_India_Assurance_VehicleCode_25,
      "united_India_Insurance_VehicleCode_26": this.United_India_Insurance_VehicleCode_26,
      "zuno_Insurance_VehicleCode_27": this.Zuno_Insurance_VehicleCode_27,
      "aditya_Birla_Health_VehicleCode_28": this.Aditya_Birla_Health_VehicleCode_28,
      "aiC_of_India_VehicleCode_29": this.AIC_of_India_VehicleCode_29,
      "care_Health_VehicleCode_30": this.Care_Health_VehicleCode_30,
      "manipalCigna_VehicleCode_31": this.ManipalCigna_VehicleCode_31,
      "niva_Bupa_VehicleCode_32": this.Niva_Bupa_VehicleCode_32,
      "star_Health_VehicleCode_33": this.Star_Health_VehicleCode_33
    }

    let res = await this.lookUpService.UpdateMMVMappingById(obj);
    if (res != null && res.isSuccess && res.result && res.result?.code == 1) {
      this.resetMappingField();
      this.fuelTypeList = [];
      this.fuelType = "";
      this.showMappingDetails = false;
      this.vehicleType = 1;
      this.loadFuelList();
    }
    swal.fire({
      position: 'center',
      icon: res?.result?.code == 0 ? 'error' : 'success',
      title: res?.result?.message ?? "Something wend wrong.",
      showConfirmButton: false,
      timer: 3000,
    });
  }

  clearCode(insuranceCompany : number){
    let selectedInsCompany = this.activeInsuranceCompanyList?.filter((f:any)=> {return f?.id == insuranceCompany}).map((m: any) => { return m?.name });
    swal.fire({
          title:'',
          text: '',
          html: "Are you sure you want to clear the mapped data of <b>"+ selectedInsCompany +"</b>?",
          showDenyButton: false,
          showCancelButton: true,   
          cancelButtonText:"Cancel",     
          denyButtonText: "Don't Continue",
          denyButtonColor:"#0DB561",
          confirmButtonText: "Yes, Continue",
          confirmButtonColor:"#0DB561",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
           this.setMappingData(insuranceCompany,"","","");
          } else if (result.isDenied) {            
          }
        });
  }

  resetActiveInsuranceComapny(){
    this.Digit_Insurance_1 = false;
    this.Royal_Sundaram_2 = false;
    this.HDFC_ERGO_3 = false;
    this.ICICI_Lombard_4 = false;
    this.IFFCO_Tokio_5 = false;
    this.Raheja_QBE_6 = false;
    this.Reliance_General_7 = false;
    this.Shriram_General_8 = false;
    this.Universal_Sompo_9 = false;
    this.Navi_Insurance_10 = false;
    this.Bajaj_Allianz_General_11 = false;
    this.National_Insurance_12 = false;
    this.Oriental_Insurance_13 = false;
    this.Future_Generali_14 = false;
    this.Edelweiss_General_15 = false;
    this.Kotak_General_16 = false;
    this.Liberty_General_17 = false;
    this.Magma_HDI_18 = false;
    this.SBI_General_19 = false;
    this.Tata_AIG_20 = false;
    this.Acko_21 = false;
    this.Bharti_AXA_22 = false;
    this.Chola_MS_23 = false;
    this.DHFL_GI_24 = false;
    this.New_India_Assurance_25 = false;
    this.United_India_Insurance_26 = false;
    this.Zuno_Insurance_27 = false;
    this.Aditya_Birla_Health_28 = false;
    this.AIC_of_India_29 = false;
    this.Care_Health_30 = false;
    this.ManipalCigna_31 = false;
    this.Niva_Bupa_32 = false;
    this.Star_Health_33 = false;
  }

  resetMakeList(){
    this.Digit_Insurance_1_MakeList = [];
    this.Royal_Sundaram_2_MakeList = [];
    this.HDFC_ERGO_3_MakeList = [];
    this.ICICI_Lombard_4_MakeList = [];
    this.IFFCO_Tokio_5_MakeList = [];
    this.Raheja_QBE_6_MakeList = [];
    this.Reliance_General_7_MakeList = [];
    this.Shriram_General_8_MakeList = [];
    this.Universal_Sompo_9_MakeList = [];
    this.Navi_Insurance_10_MakeList = [];
    this.Bajaj_Allianz_General_11_MakeList = [];
    this.National_Insurance_12_MakeList = [];
    this.Oriental_Insurance_13_MakeList = [];
    this.Future_Generali_14_MakeList = [];
    this.Edelweiss_General_15_MakeList = [];
    this.Kotak_General_16_MakeList = [];
    this.Liberty_General_17_MakeList = [];
    this.Magma_HDI_18_MakeList = [];
    this.SBI_General_19_MakeList = [];
    this.Tata_AIG_20_MakeList = [];
    this.Acko_21_MakeList = [];
    this.Bharti_AXA_22_MakeList = [];
    this.Chola_MS_23_MakeList = [];
    this.DHFL_GI_24_MakeList = [];
    this.New_India_Assurance_25_MakeList = [];
    this.United_India_Insurance_26_MakeList = [];
    this.Zuno_Insurance_27_MakeList = [];
    this.Aditya_Birla_Health_28_MakeList = [];
    this.AIC_of_India_29_MakeList = [];
    this.Care_Health_30_MakeList = [];
    this.ManipalCigna_31_MakeList = [];
    this.Niva_Bupa_32_MakeList = [];
    this.Star_Health_33_MakeList = [];
  }

  resetModelList(){
    this.Digit_Insurance_1_ModelList = [];
    this.Royal_Sundaram_2_ModelList = [];
    this.HDFC_ERGO_3_ModelList = [];
    this.ICICI_Lombard_4_ModelList = [];
    this.IFFCO_Tokio_5_ModelList = [];
    this.Raheja_QBE_6_ModelList = [];
    this.Reliance_General_7_ModelList = [];
    this.Shriram_General_8_ModelList = [];
    this.Universal_Sompo_9_ModelList = [];
    this.Navi_Insurance_10_ModelList = [];
    this.Bajaj_Allianz_General_11_ModelList = [];
    this.National_Insurance_12_ModelList = [];
    this.Oriental_Insurance_13_ModelList = [];
    this.Future_Generali_14_ModelList = [];
    this.Edelweiss_General_15_ModelList = [];
    this.Kotak_General_16_ModelList = [];
    this.Liberty_General_17_ModelList = [];
    this.Magma_HDI_18_ModelList = [];
    this.SBI_General_19_ModelList = [];
    this.Tata_AIG_20_ModelList = [];
    this.Acko_21_ModelList = [];
    this.Bharti_AXA_22_ModelList = [];
    this.Chola_MS_23_ModelList = [];
    this.DHFL_GI_24_ModelList = [];
    this.New_India_Assurance_25_ModelList = [];
    this.United_India_Insurance_26_ModelList = [];
    this.Zuno_Insurance_27_ModelList = [];
    this.Aditya_Birla_Health_28_ModelList = [];
    this.AIC_of_India_29_ModelList = [];
    this.Care_Health_30_ModelList = [];
    this.ManipalCigna_31_ModelList = [];
    this.Niva_Bupa_32_ModelList = [];
    this.Star_Health_33_ModelList = [];
  }
}
